import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { PaneResponsiveCardGrid } from '@/components/layout/pane-responsive-card-grid'
import { ListCardSkeleton } from '@/components/layout/list-card-skeleton'
import { cn } from '@/lib/utils'

export function AdminStatCardsSkeleton({
  count = 4,
  ariaLabel = 'Loading stats',
  className,
}: {
  count?: number
  ariaLabel?: string
  className?: string
}) {
  return (
    <div
      className={cn('grid grid-cols-1 gap-4 @2col:grid-cols-2 @4col:grid-cols-4', className)}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      {Array.from({ length: count }).map((_, index) => (
        <Card key={index}>
          <CardHeader className="space-y-2">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-8 w-16" />
          </CardHeader>
        </Card>
      ))}
    </div>
  )
}

export function AdminChartSkeleton({
  ariaLabel = 'Loading chart',
  className,
}: {
  ariaLabel?: string
  className?: string
}) {
  return (
    <Card className={className}>
      <CardHeader>
        <Skeleton className="h-5 w-40" />
        <Skeleton className="h-4 w-56" />
      </CardHeader>
      <CardContent>
        <div
          className="space-y-3"
          role="status"
          aria-live="polite"
          aria-busy="true"
          aria-label={ariaLabel}
        >
          {Array.from({ length: 5 }).map((_, index) => (
            <Skeleton key={index} className="h-8 w-full" style={{ width: `${100 - index * 12}%` }} />
          ))}
        </div>
      </CardContent>
    </Card>
  )
}

export function AdminListGridSkeleton({
  count = 6,
  ariaLabel = 'Loading list',
  className,
}: {
  count?: number
  ariaLabel?: string
  className?: string
}) {
  return (
    <PaneResponsiveCardGrid
      className={className}
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label={ariaLabel}
    >
      {Array.from({ length: count }).map((_, index) => (
        <ListCardSkeleton key={index} showFooter={false} />
      ))}
    </PaneResponsiveCardGrid>
  )
}
